module.exports = __webpack_public_path__ + "static/media/regMrezaBack.138fbeba.jpg";